/* import __COLOCATED_TEMPLATE__ from './releases-assigned.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent-2 */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type Session from 'embercom/services/session';
import type RenderablePart from 'embercom/objects/inbox/renderable-part';
import type ReleasesAssigned from 'embercom/objects/inbox/renderable/releases-assigned';

interface ReleasesAssignedPart extends RenderablePart {
  renderableData: ReleasesAssigned;
}

interface Args {
  part: ReleasesAssignedPart;
}

interface Signature {
  Args: Args;
}

export default class ReleasesAssignedComponent extends Component<Signature> {
  @service declare session: Session;

  get releases() {
    let appId = this.session.workspace.id;
    return this.args.part.renderableData.releases.map((release) => ({
      ...release,
      url: `/a/apps/${appId}/automation/fin-ai-agent/releases/${release.id}`,
    }));
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationStream::EventParts::ReleasesAssigned': typeof ReleasesAssignedComponent;
    'inbox2/conversation-stream/event-parts/releases-assigned': typeof ReleasesAssignedComponent;
  }
}
